import dayjs from 'dayjs/esm/index.js'

export function parseFormat(date: string | Date | undefined): string {
  if (!date) return ''
  const parsed = new Date(date)
  if (isNaN(parsed.valueOf())) return ''
  return `${parsed.toLocaleDateString('en-GB')} ${parsed.toLocaleTimeString('en-US')}`
}

export function formatPostgresDate(
  postgresDateString: string,
  outputFormat = 'YYYY-MM-DD hh:mm:ss A'
) {
  // Parse the PostgreSQL date string
  const parsedDate = dayjs(postgresDateString)

  // Format the date with the specified output format
  const formattedDate = parsedDate.format(outputFormat)

  return formattedDate
}

export function formatDate(
  date: Date,
  outputFormat = 'YYYY-MM-DD hh:mm:ss A'
) {
  // Parse the PostgreSQL date string
  const parsedDate = dayjs(date)

  // Format the date with the specified output format
  const formattedDate = parsedDate.format(outputFormat)

  return formattedDate
}

export function formatAge(postgresDateString: string, returnNumber = false): string {
  if (!postgresDateString) return '-'
  const birthdate = dayjs(postgresDateString)
  if (!birthdate.isValid() || birthdate.year() <= 1900) return '-'

  const currentDate = dayjs()

  // Calculate the difference in years and months
  const years = currentDate.diff(birthdate, 'year')
  const months = currentDate.diff(birthdate.add(years, 'year'), 'month')

  if (returnNumber) {
    return years.toString()
  }

  return `${years}y ${months}m`
}


export function parseDate(dateStr) {
  const parts = dateStr.split("/"); // Split the date string
  if (parts.length !== 3) return null; // Ensure it has day, month, and year

  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);

  const date = new Date(year, month, day);
  return isNaN(date.getTime()) ? null : date;
}
